// @flow
import React from 'react'

const Tick = ({
  color,
  height = 13,
  width = 16
}: {
  color: string,
  height?: number,
  width?: number
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
    >
      <path
        fill="none"
        fillRule="evenodd"
        stroke={color}
        strokeLinecap="square"
        strokeWidth="3"
        d="M3 7l3 3 7.032-6.994"
      />
    </svg>
  )
}

export default Tick



// WEBPACK FOOTER //
// ./src/components/Icons/Tick.js